// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"792":"main","884":"admin"}[chunkId] + "." + {"792":"7aaf3a0e87077311851e","884":"4db6ffffbda67a7d6ef4"}[chunkId] + ".css";
};